/**
 * La marca entera: mascota, logotipo «véltica» y la etiqueta «beta», en ese
 * orden —«beta» califica a la marca, así que va detrás y no en medio—.
 *
 * Una sola pieza para todos los sitios donde sale (la barra de arriba, el menú
 * lateral del teléfono): estaba escrita a mano en cada uno y en el menú del
 * teléfono faltaba el logotipo. Va dentro del botón que la contiene, que es de
 * quien la pone.
 *
 * Con medidas en el logotipo: sin ellas el hueco vale cero hasta que llega el
 * dibujo y la barra da un salto. Salen de su proporción real, 167 × 46.
 */
import { VelticaMascot } from '@webbuilder/ui'
import { useI18n } from '../lib/i18n'

export function BrandLockup({ mascotSize = 28, mascotClassName = 'dash-onboarding-brand-mascot' }: {
  mascotSize?: number
  mascotClassName?: string
}) {
  const { t } = useI18n()
  return (
    <>
      <VelticaMascot className={mascotClassName} size={mascotSize} />
      <img className="dash-onboarding-brand-logo" src="/veltica.svg" alt="véltica" width={54} height={15} decoding="sync" fetchPriority="high" />
      <span className="dash-beta-badge">{t('topbar.beta')}</span>
    </>
  )
}
